import React from "react";
import { ReactDatePickerCustomHeaderProps } from "react-datepicker";
import { MONTHS, years } from "../../utils";
import { getMonth, getYear } from "date-fns";
import { ReactComponent as TickIcon } from "src/images/tick.svg";

import {
  Dropdown,
  DropdownMenu,
  DropdownMenuItem,
} from "src/app/components/Dropdown/Dropdown";

import "./CustomDatePickerHeader.scss";

export const CustomDatePickerHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) => {
  return (
    <div
      className="date-picker-custom-header"
      style={{
        margin: 10,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
        {"<"}
      </button>

      <div className="date-picker-custom-header__selectors">
        <Dropdown>
          {(isOpen, setIsOpen) => (
            <>
              <span onClick={() => setIsOpen(true)}>
                {MONTHS[getMonth(date)]}
              </span>
              <DropdownMenu isOpen={isOpen}>
                {MONTHS.map((option) => (
                  <DropdownMenuItem
                    key={option}
                    onClick={() => {
                      changeMonth(MONTHS.indexOf(option));
                      setIsOpen(false);
                    }}
                  >
                    {option}
                    {option === MONTHS[getMonth(date)] && <TickIcon />}
                  </DropdownMenuItem>
                ))}
              </DropdownMenu>
            </>
          )}
        </Dropdown>

        <Dropdown>
          {(isOpen, setIsOpen) => (
            <>
              <span onClick={() => setIsOpen(true)}>{getYear(date)}</span>
              <DropdownMenu isOpen={isOpen}>
                {years.map((option) => (
                  <DropdownMenuItem
                    key={option}
                    onClick={() => {
                      changeYear(+option);
                      setIsOpen(false);
                    }}
                  >
                    {option}
                    {option === getYear(date) && <TickIcon />}
                  </DropdownMenuItem>
                ))}
              </DropdownMenu>
            </>
          )}
        </Dropdown>
      </div>

      <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
        {">"}
      </button>
    </div>
  );
};
